import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { getDeathClaim } from '../../../claim/reducers/claim-reducers/death-claim-reducer';
import { State } from '../../../redux/root-reducer';
import { ForensicInputView } from '../common/forensic-input';
import { InformationRecordView } from '../common/information-record';
import { MedicalOfficerInputView } from '../common/medical-officer-input';
import { PoliceReportView } from '../common/police-report/views/police-report-view';
import { ReinsuranceInputView } from '../common/reinsurance-input';
import { Synopsis } from '../common/synopsis/synopsis';
import { ClaimEventDetailsView } from './claim-event-details';
import { ClaimantDetailsView } from './claimant-details/views/claimant-details';
import { ContactDetailsView } from './contact-details';
import { LifeAssuredDetailsView } from './life-assured-details';
import { NoticeOfDeathView } from './notice-of-death/notice-of-death';
import { DeathPolicySummaryView } from './policy-details';
import { RequirementManagementView } from './manage-requirements/views/requirement-management';
import { NonRaDeathWrapper } from '../../../forms';
import { RulesResultsView } from '../common/rules/views/results-view';
import { CommunicationsView } from './communications-details/views/contact-details';

interface UWProps {
    under3Years: boolean;
}

interface InnerProps extends UWProps {
    hasRisk: boolean;
}

const deathSynopsisView = ({ ...rest }: InnerProps) => {
    return (
        <Synopsis>
            <RequirementManagementView />
            <ClaimantDetailsView />
            <ContactDetailsView />
            <CommunicationsView />
            <LifeAssuredDetailsView />
            <NonRaDeathWrapper>
                <DeathPolicySummaryView />
            </NonRaDeathWrapper>
            <ClaimEventDetailsView />
            <NonRaDeathWrapper>
                <InformationRecordView />
                <ReinsuranceInputView />
                <MedicalOfficerInputView />
                <ForensicInputView />
            </NonRaDeathWrapper>
            <NoticeOfDeathView />
            <PoliceReportView />
            <RulesResultsView />
        </Synopsis>
    );
};

const mapStateToProps = (state: State) => {
    const claim = getDeathClaim(state);
    return {
        under3Years: claim.hasLifeCoverUnder3Years || false,
        hasRisk: claim.hasRisk || false,
    };
};

export const DeathSynopsis = connect(mapStateToProps, {})(deathSynopsisView);
